var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sw-announcement-banner',{attrs:{"show-banner":_vm.showAppEOLBanner,"eol-date":_vm.appEOLDate}}),_vm._v(" "),(_vm.showWorkspace)?_c('div',[_c('router-view')],1):_c('div',[_c('sw-app-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }